<template>
<div>
  <v-flex xs10 offset-xs1>
    <div class='fl hf'>
      <div class='golden-left'>
        <h1 class='mb-4'>{{ 'recovery.edit.title' | translate }}</h1>
      </div>
    </div>

    <div class='fl hf'>
      <div class='golden-left'>
        <EditRecoveryInputForm v-if="activeView === views.EditRecoveryInputForm"
          :reportOfSickness="_reportOfSickness"
          :employee="employee" />

        <EditRecoveryConfirmation v-if="activeView === views.EditRecoveryConfirmation"
          :reportOfSickness="_reportOfSickness"
          :employee="employee" />
      </div>

      <div class='golden-right'>
        <ProgressStepper :steps="steps" :sticky="320" />
      </div>
    </div>
  </v-flex>
</div>
</template>

<script>
import { mapGetters } from 'vuex';

import ProgressStepper from '@aevitae/aevitaeui/1_molecules/stepper/ProgressStepper.vue';
import EditRecoveryInputForm from '@/views/components/recovery-edit/EditRecoveryInputForm.vue';
import EditRecoveryConfirmation from '@/views/components/recovery-edit/EditRecoveryConfirmation.vue';

import EditRecoveryConstants from '@/views/constants/recovery-edit';

export default {
  name: 'EditRecovery',
  props: {
    _reportOfSickness: Object
  },
  data () {
    return {
      views: EditRecoveryConstants.Views
    };
  },
  components: {
    ProgressStepper,
    EditRecoveryInputForm,
    EditRecoveryConfirmation
  },
  computed: {
    ...mapGetters({
      steps: 'editRecoverySteps',
      activeView: 'editRecoveryActiveView'
    }),
    employee () {
      return this.$store.getters.employees.find(employee =>
        employee.id === this._reportOfSickness.employeeId);
    }
  }
};
</script>
